import { ISapImportValidationError, ISapImportValidationPayload } from "@/types"

export interface ISapImportValidationState {
  isValid: boolean
  requiredFields: string[]
  validationErrors: ISapImportValidationError[]
}

export const EMPTY_SAP_IMPORT_VALIDATION: ISapImportValidationState = {
  isValid: true,
  requiredFields: [],
  validationErrors: [],
}

export const normalizeSapImportValidation = (
  payload?: ISapImportValidationPayload | null,
): ISapImportValidationState => {
  const requiredFields = Array.isArray(payload?.required_fields)
    ? payload.required_fields
    : []
  const validationErrors = Array.isArray(payload?.validation_errors)
    ? payload.validation_errors
    : []

  return {
    isValid:
      typeof payload?.is_valid === "boolean"
        ? payload.is_valid
        : validationErrors.length === 0,
    requiredFields,
    validationErrors,
  }
}

export const extractSapImportValidationFromError = (
  error: unknown,
): ISapImportValidationState => {
  if (
    error &&
    typeof error === "object" &&
    "response" in error &&
    error.response &&
    typeof error.response === "object" &&
    "data" in error.response
  ) {
    const responseData = error.response.data as {
      data?: ISapImportValidationPayload
    }

    return normalizeSapImportValidation(responseData?.data)
  }

  return EMPTY_SAP_IMPORT_VALIDATION
}
